// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"Share":"34f0e8eeafbd8e497121","ContentImport":"5ea444f17f6c6ae1b7f9","Queue":"947e3065690254ee67ce","Stats":"ef803650f2cc02a8a124","Settings":"9ab43bb03f37e3caaafa","ClientApp":"3310a0007e210bb02f5c"}[chunkId] + ".bundle.js";
};